
// _process.js
export default function initProcess() {
  const items = document.querySelectorAll('.process__desc');
  if (!items.length) return;

  items.forEach(item => {
    item.addEventListener('click', () => {
      item.classList.toggle('expanded');
    });
  });
}